/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-09-28 18:26:02
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';

import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { Icon } from '@shopify/polaris';
import { CaretDownMinor, CaretUpMinor } from '@shopify/polaris-icons';
import { CSSTransition } from 'react-transition-group';

import { RECOMMENDATION_WIDGET_PAGE_TYPES } from 'src/constants/recommendation';

type Props = {
  pageType: string,
  index: number,
  isSearch: Boolean,
  widgets: Array<Object>,
  handleDelete: Function
};

type ComposedProps = Props & WithI18nProps;

type State = {
  active: boolean
};

class PageTypeCollapse extends Component<ComposedProps, State> {
  state = {
    active: true
  };

  render() {
    const { i18n, pageType } = this.props;
    const { active } = this.state;

    return (
      <>
        <div className="recommendation-translation">
          <div
            onClick={this.toggleContent}
            className={`recommendation-translation-collapse ${active ? 'active' : 'not-active'}`}>
            <span className="page-type-collapse-icon">
              <Icon source={active ? CaretDownMinor : CaretUpMinor} color="base" />
            </span>
            <span>{i18n.translate(RECOMMENDATION_WIDGET_PAGE_TYPES[pageType].name)}</span>
          </div>
        </div>
        <CSSTransition
          in={active}
          timeout={200}
          classNames="item-transition transition"
          unmountOnExit>
          {this.props.children}
        </CSSTransition>
      </>
    );
  }

  // collapse or expand action
  toggleContent = () => {
    this.setState(({ active }) => ({
      active: !active
    }));
  };
}

export default withI18n()(PageTypeCollapse);
